<template>
  <div class="rules-container">
    <div class="rules-title">{{ title }}</div>
    <div class="rules-notes">{{ note }}</div>
    <div class="rules-tags">
      <rich-tag v-for="vehicle in vehicles" :key="vehicle">{{ vehicle }}</rich-tag>
    </div>
    <div class="rules-button" @click="handleMoreRules">
      <span>{{ $t('FoodD_optimization_lXdy_Scjt'/** 更多规则 */) }}</span>
      <i class="icon-v3_outlined_entrance icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityRules',
  props: {
    rule: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    title () {
      const { rule: { title } = {} } = this
      return title || ''
    },
    note () {
      const { rule: { attention } = {} } = this
      return attention || ''
    },
    vehicles () {
      const { rule: { vehicles } = {} } = this
      return vehicles || ''
    }
  },
  methods: {
    handleMoreRules () {
      this.$emit('clickToDetail')
    }
  }
}
</script>

<style lang='stylus' scoped>
.rules-container {
  background: #fff;
  border-radius: 32px;
  padding: 52px 40px 40px;

  .rules-title {
    font-family: DiDiSans-Pro-Medium;
    font-size: 40px;
    color: #000;
    letter-spacing: 0;
    line-height: 48px;
    margin-bottom: 23px;
  }

  .rules-notes {
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: rgba(0, 0, 0, .5);
    letter-spacing: 0;
    line-height: 30px;
    margin-bottom: 16px;
  }

  .rules-tags {
    margin-bottom: 40px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    :not(:last-child) {
      margin-right: 8px;
    }

    ::v-deep .rich-tag {
      padding: 4px 8px;
      color: rgba(0, 0, 0, .5);
      background: #F4F4F6;
      margin-bottom: 8px;

      .rich-tag-content {
        font-family: DiDiSans-Pro-Regular;
        font-size: 24px;
        padding: 4px 8px;
      }
    }
  }

  .rules-button {
    font-family: DiDiSans-Pro-Medium;
    font-size: 28px;
    color: #000;
    letter-spacing: 0;
    line-height: 28px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .icon {
      font-size: 18px;
      margin-left: 4px;
      margin-top: 2px;
      font-weight: 800;
      color: #000;
    }
  }
}
</style>